import { useContext } from 'react'

import { MediaContext } from '@/contexts'

export const useMedia = () => useContext(MediaContext)
